import React from "react";
import { Link } from "react-router-dom";
import "./LandingHeader.css";

const LandingHeader = () => {
  return (
    <header className="container1 header1">
      <a href="/" className="logo">Shutter</a>
      <nav className="nav-links">
        <Link to="/use-cases">Use Cases</Link>
        <Link to="/pricing">Pricing</Link>
      </nav>
      <div className="spacer" />
      <a href="/webapp" className="login-btn">Login</a>
    </header>
  );
};

export default LandingHeader; 